import { render } from "./Success.vue?vue&type=template&id=541bc73b"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"
script.render = render

export default script